import { useTranslation } from '@frontend/i18n';
import { ValidatorFieldState, useForm } from '@frontend/design-system';
import { UsePairYourTerminalProps, useRegisterTerminalRequest } from '../pair-terminal';

const PAIRING_CODE_REGEX = /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+){2}$/;

export const usePairS710Terminal = (props: UsePairYourTerminalProps) => {
  const { t } = useTranslation('payments');

  const { registerTerminal, isLoading, showStatus, error, resetRequestStatus } = useRegisterTerminalRequest(props);

  const { values, getFieldProps, isComplete, reset } = useForm({
    fields: {
      pairingCode: {
        type: 'text',
        required: true,
        validator: (field: ValidatorFieldState<'text'>) =>
          PAIRING_CODE_REGEX.test(field.value.trim())
            ? ''
            : t('Enter the three-word code separated by hyphens, e.g. apple-river-stone.'),
      },
      terminalName: {
        type: 'text',
        required: true,
        validator: (field: ValidatorFieldState<'text'>) =>
          /^[a-zA-Z0-9- _.]+$/.test(field.value) ? '' : t('Only letters, numbers, spaces, "-", "_" are allowed.'),
      },
    },
  });

  const handleRegisterTerminal = () => {
    if (values.pairingCode && values.terminalName) {
      resetRequestStatus();
      registerTerminal(values.pairingCode.trim(), values.terminalName);
    }
  };

  const resetStatus = () => {
    resetRequestStatus();
    reset();
  };

  return { getFieldProps, isComplete, isLoading, handleRegisterTerminal, showStatus, error, resetStatus };
};
